import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
const points = ['Querés comenzar tu camino espiritual pero no sabés por dónde empezar', 'Ya sos terapeuta y querés ampliar tus herramientas sin pagar cursos carísimos por separado', 'Sentís el llamado de emprender en lo holístico pero necesitás una base clara', 'Querés sanar desde adentro, entender la energía y conectar con tu intuición', 'Pagaste cursos sueltos antes y nunca sentiste que era suficiente', 'Querés tener una biblioteca completa para consultar cuando quieras'];
interface IdentificationSectionProps {
  onCheckout: () => void;
}
export function IdentificationSection({
  onCheckout
}: IdentificationSectionProps) {
  return <section className="py-12 bg-white" data-id="element-169">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-serif font-bold text-center text-black mb-10" data-id="element-171">
          Este Pack es para vos si…
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-172">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gray-50 border border-gray-100 p-5 rounded-xl flex items-start gap-4" data-id="element-173">
              <span className="text-3xl font-serif font-bold text-terracotta/30 leading-none" data-id="element-174">
                {String(index + 1).padStart(2, '0')}
              </span>
              <p className="text-gray-800 font-medium leading-relaxed pt-1" data-id="element-175">
                {point}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-176">
          <p className="text-lg font-serif italic text-gray-600 mb-6" data-id="element-177">
            "Si te identificás con aunque sea uno de estos puntos, este Pack fue
            creado para vos."
          </p>
          <Button onClick={onCheckout} className="px-10" data-id="element-178">
            QUIERO ACCEDER A MI PACK AHORA
          </Button>
        </motion.div>
      </div>
    </section>;
}